import React, { useState } from 'react';
import {Row, Col, Label, Input, Button, FormGroup} from 'reactstrap';
import ToggleSwitch from '../../../components/ToggleSwitch';
import { DatePicker } from '../../../components/DateTime';

const Membership = ({ initialSettings, onSave }) => {
    const [settings, setSettings] = useState(initialSettings || {});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSettings((prevSettings) => ({
            ...prevSettings,
            [name]: value,
        }));
    };

    return (
        <div>
            <Row className="mt-3">
                <Col className="d-flex flex-row align-items-center">
                    <FormGroup className="ms-md-3">
                        <Label>Active?</Label>
                            <ToggleSwitch
                                isOn={settings?.active}
                                onChange={value => handleChange({target: {name: 'active', value}})}
                            />
                    </FormGroup>
                </Col>
            </Row>

            <Row className="mt-3">
                <Col className="d-flex flex-row align-items-center">
                    <FormGroup className="ms-md-3 w-100">
                        <Label>Membership Type</Label>
                        <Input
                            type="text"
                            name="membershipType"
                            placeholder="Membership Type"
                            value={settings.membershipType || ''}
                            onChange={handleChange}
                        />
                    </FormGroup>
                </Col>
            </Row>

            <Row className="mt-3">
                <Col className="d-flex flex-row align-items-center">
                    <FormGroup className="ms-md-3 w-100">
                        <Label>Renewal Date</Label>
                        <DatePicker
                            value={settings.renewalDate}
                            onChange={date => handleChange({target: {name: 'renewalDate', value: date}})}
                            placeholder="Renewal date"
                            clearable
                        />
                    </FormGroup>
                </Col>

                <Col className="d-flex flex-row align-items-center">
                    <FormGroup className="ms-md-3 w-100">
                        <Label>Annual Membership Cost</Label>
                        <Input
                            type="number"
                            name="annualMembershipCost"
                            value={settings.annualMembershipCost || ''}
                            onChange={handleChange}
                        />
                    </FormGroup>
                </Col>
            </Row>

            <Row className="mt-3">
                <Col className="d-flex flex-row align-items-center">
                    <FormGroup className="ms-md-3 w-100">
                        <Label>Commissioning Date</Label>
                        <DatePicker
                            value={settings.commissioningDate}
                            onChange={date => handleChange({target: {name: 'commissioningDate', value: date}})}
                            placeholder="Commissioning date"
                            clearable
                        />
                    </FormGroup>
                </Col>

                {!settings?.active && (
                    <Col className="d-flex flex-row align-items-center">
                        <FormGroup className="ms-md-3 w-100">
                            <Label>Inactive From</Label>
                            <DatePicker
                                value={settings.inactiveFrom}
                                onChange={date => handleChange({target: {name: 'inactiveFrom', value: date}})}
                                placeholder="Inactive from"
                                clearable
                            />
                        </FormGroup>
                    </Col>
                )}
            </Row>

            <Row className="mt-3">
                <Col className="d-flex flex-row align-items-center">
                    <FormGroup className="ms-md-3 w-100">
                        <Label><span className="fas fa-lock text-primary me-2" />Private Notes (Visible to BAC only):</Label>
                        <Input
                            type="textarea"
                            placeholder="Private notes about membership"
                            className="pt-3 w-100"
                            name="bacNotes"
                            value={settings.bacNotes}
                            onChange={handleChange}
                        />
                    </FormGroup>
                </Col>
            </Row>

            <div className="d-flex justify-content-end mt-3">
                <Button color="primary" outline onClick={() => onSave(settings)}>
                    <span className="fas fa-save me-2" /> Save Changes
                </Button>
            </div>
        </div>
    );
};

export default Membership;
